<template>

    <div>
        <!-- <PaymentView /> -->
         <SubscriptionDetailsView />
    </div>
</template>

<script>
import PaymentView from "./profile_details_components/PaymentView.vue";
import SubscriptionDetailsView from "./profile_details_components/SubscriptionDetailsView.vue";
export default {
    name: "GardenHelpContractorSubscription",
    components: {
        PaymentView,
        SubscriptionDetailsView
    }
}
</script>


// WEBPACK FOOTER //
// src/projects/garden_help/contractor/subscriptions.vue